import { Truck } from 'lucide-react';
import { OrderTags } from './Tags';
import { cn, daysFromToday, fmtDate, fmtVolume, fmtWeight, qty } from '../lib/utils';

/* One open order, two lines: the order and its supplier on one baseline,
   then when it is due, how big it is and what to know, with the units still
   to receive standing alone on the right. */
export default function OrderRow({ order, onOpen, onPrefetch }) {
  const days = daysFromToday(order.expected);
  const late = days !== null && days < 0;
  return (
    <button
      type="button"
      onClick={() => onOpen?.(order)}
      onTouchStart={() => onPrefetch?.(order)}
      onMouseEnter={() => onPrefetch?.(order)}
      className="flex w-full items-center gap-3 rounded-xl bg-surface px-3 py-2 text-left active:bg-sunken"
    >
      <span className="min-w-0 flex-1">
        <span className="flex items-baseline gap-2">
          <span className="font-cond max-w-[62%] shrink-0 truncate text-[19px] font-bold leading-none">{order.name}</span>
          <span className="min-w-0 truncate text-[13px] text-ink2">{order.supplier}</span>
        </span>
        <span className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] text-ink2">
          {order.partner_ref && <span title="Vendor reference" className="max-w-[45%] truncate font-mono">{order.partner_ref}</span>}
          {order.expected && <span className={cn(late && 'font-semibold text-hold')}>{late ? `due ${fmtDate(order.expected)}` : fmtDate(order.expected)}</span>}
          {order.lines > 0 && (
            <span>
              {order.open_lines > 0 && order.open_lines < order.lines
                ? `${order.open_lines} of ${order.lines} ${order.lines === 1 ? 'line' : 'lines'} open`
                : `${order.lines} ${order.lines === 1 ? 'line' : 'lines'}`}
            </span>
          )}
          {order.volume_l > 0 && (
            <span title="From confirmed packaging only">
              {fmtVolume(order.volume_l)}
              {order.weight_kg > 0 && ` · ${fmtWeight(order.weight_kg)}`}
            </span>
          )}
          {order.shipped_pending && (
            <span className="inline-flex items-center gap-1 font-semibold text-ink">
              <Truck className="h-3.5 w-3.5" /> {order.shipped_lines}/{order.lines} shipped
            </span>
          )}
        </span>
        {/* tags on a line of their own, so every row breaks in the same place */}
        <OrderTags order={order} compact />
      </span>
      <span className="shrink-0 text-right">
        <span className="font-cond block text-[24px] font-bold leading-none">{qty(order.qty_outstanding)}</span>
        <span className="block text-[11px] font-semibold uppercase tracking-wide text-ink2">to receive</span>
      </span>
    </button>
  );
}
